import { StudentLectureMaster } from './StudentLectureMaster.model';
import { DocumentMaster } from './DocumentMaster.model';

export class StudentLectureContentMaster{
    public studentLectureContentMasterId:number;
    public studentLectureMaster:StudentLectureMaster;
    public documentMaster:DocumentMaster;
    public isCompleted:Boolean;
    public watchedTime:string;
}